export const SERVER_FORMAT_DATE = 'MM/DD/YY';
export const SERVER_FORMAT_DATE_LONG = 'MM/DD/YYYY';

export const DB_DATE_FORMAT = 'YYYY-MM-DD';
export const DB_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DB_DATE_TIME_SHORT_FORMAT = 'YYYY-MM-DD HH:mm';

export const DEFAULT_DISPLAY_DATE_FORMAT = 'MMMM DD, YYYY';
export const DATE_MONTH_YEAR_LONG_FORMAT = 'MMMM, YYYY';
export const DATE_MONTH_YEAR_SHORT_FORMAT = 'MM/YYYY';

export const DEFAULT_TIME_FORMAT = 'H:mm';

// The zone the backend writes its timestamps in (config.php); they carry no offset.
export const SERVER_TIMEZONE = 'America/New_York';

export const DEFAULT_NON_EXPIRY_DATE = '2099-12-31 19:00:00';
